import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './pages/home/home.component';
import { Routes, RouterModule } from '@angular/router';
import { UiModule } from '../../../shared/ui/src';

const COMPONENTS = [HomeComponent];

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes), UiModule],
  declarations: [COMPONENTS]
})
export class LandingPageModule {}
